import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

export const operationsQueueKindV1Schema = z.enum([
  "dispatch_freshness",
  "offline_backlog",
  "missing_gps",
  "completion_exception",
  "billing_exception",
  "support_sla",
  "provider_failure",
])

export const operationsQueueItemV1Schema = z.object({
  itemId: z.string().min(1).max(160),
  kind: operationsQueueKindV1Schema,
  sourceEntityId: entityIdSchema,
  branchId: entityIdSchema.nullable(),
  state: z.string().min(1).max(40),
  reasonCode: z.string().min(1).max(80),
  occurredAt: z.iso.datetime({ offset: true }),
  ageSeconds: z.number().int().nonnegative(),
}).strict()

export const operationsDashboardV1Schema = z.object({
  projectionVersion: z.literal(1),
  observedAt: z.iso.datetime({ offset: true }),
  complete: z.boolean(),
  serverObservedOfflineOnly: z.literal(true),
  summary: z.object({
    dispatchFreshness: z.number().int().nonnegative(),
    offlineBacklog: z.number().int().nonnegative(),
    missingGps: z.number().int().nonnegative(),
    completionExceptions: z.number().int().nonnegative(),
    billingExceptions: z.number().int().nonnegative(),
    supportSla: z.number().int().nonnegative(),
    providerFailures: z.number().int().nonnegative(),
  }).strict(),
  queues: z.array(operationsQueueItemV1Schema).max(100),
}).strict()

export type OperationsDashboardV1 = z.infer<typeof operationsDashboardV1Schema>
export type OperationsQueueKindV1 = z.infer<typeof operationsQueueKindV1Schema>
